import { fetchEB } from '@eventbrite/legacy-infra.http';

export class BffRequestHandler {
    private baseUrl: string;

    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    async request<T = any>(url: string, options: RequestInit = {}): Promise<T> {
        // Construct the full path - fetchEB will handle default headers and CSRF token
        // Routes are for conversions-manager-webapp which doesn't use the /e basePath
        const fullPath = `${this.baseUrl}${url}`;
        try {
            const response = await fetchEB(fullPath, options);
            return (await response.json()) as T;
        } catch (error) {
            throw error;
        }
    }
}

